import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import { GiMoneyStack } from "react-icons/gi";
import { formatCurrency } from "../../../utils/utils";

interface BudgetRemainingCardProps {
	budgetRemaining: number;
}

const BudgetRemainingCard: React.FC<BudgetRemainingCardProps> = ({
	budgetRemaining,
}) => {
	return (
		<Row className="align-items-center justify-content-center py-0 my-3 text-center fw-bold">
			<Col s={12} md={6} className="text-center">
				<Card className="mb-1 shadow bg-dark text-white border-0">
					<Card.Body className="py-3">
						<span>
							<GiMoneyStack
								className="mb-1 me-2"
								style={{ width: "1.3rem", height: "auto" }}
							/>{" "}
							Budget Remaining:{" "}
						</span>
						<span className="text-success">
							{" "}
							{formatCurrency(budgetRemaining)}
						</span>
					</Card.Body>
				</Card>
			</Col>
		</Row>
	);
};

export default BudgetRemainingCard;
